import { observer } from "mobx-react-lite";
import FormField from "../form-field/FormField";
import React, { useMemo, useState } from "react";
import { SupportTag } from "../grid-tag/Tags";
import dateService from "../../services/date-service/DateService";
import { EmailValidatorModel } from "../../services/form/validators/email/EmailValidator";

export interface FieldProps {
    value: any;
    readonly?: boolean;
}

interface RequiredFieldProps extends FieldProps {
  isRequired?: boolean
}

interface UserNameFieldProps extends FieldProps {
  supportTag: boolean
}

interface FieldInOrganizationProps extends FieldProps {
  inOrganization: boolean
}

export const FirstNameField = observer((props: FieldProps) => {
  return (
    <FormField
      id="first-name"
      labelKey="general.first-name"
      component="input"
      className="input"
      fieldName="firstName"
      fieldValue={props.value || "-"}
      placeholderKey="general.first-name"
      errorName="firstName"
      readOnly={props.readonly}
    />
  );
})

export const LastNameField = observer((props: FieldProps) => {
  return (
    <FormField
      id="last-name"
      labelKey="general.last-name"
      component="input"
      className="input"
      fieldName="lastName"
      fieldValue={props.value || "-"}
      placeholderKey="general.last-name"
      errorName="lastName"
      readOnly={props.readonly}
    />
  );
})

export const UserNameField = observer((props: UserNameFieldProps) => {
  return (
    <div className="display-username-field">
      <FormField
        id="user-name"
        labelKey="general.user-name"
        component="input"
        className="input"
        fieldName="userName"
        placeholderKey="general.user-name"
        errorName="userName"
        readOnly={props.readonly}
        fieldValue={props.value || "-"}
        accessoryElement={props.supportTag ? <SupportTag /> : undefined}
      />
    </div>
  );
})

export const EmailField = observer((props: RequiredFieldProps) => {
  const isRequired = useMemo(() => {
    if (props.isRequired === undefined) return true;
    return props.isRequired;
  }, [props.isRequired]);

  const [emailValidator] = useState(() =>
    EmailValidatorModel.create({
      isRequired: isRequired,
    })
  );
  return (
    <FormField
      id="email"
      labelKey="general.email"
      required={isRequired}
      className="input"
      fieldName="email"
      fieldValue={props.value || "-"}
      validator={emailValidator}
      placeholderKey="general.email"
      errorName="email"
      readOnly={props.readonly}
    />
  );
})

export const PhoneField = observer((props: FieldInOrganizationProps) => {
  return (
    <FormField
      id="phone"
      labelKey={props.inOrganization ? "organization.organization-phone-number" : "general.phone"}
      component="input"
      className="input"
      fieldName="phone"
      errorName="phone"
      readOnly={props.readonly}
      fieldValue={props.value || "-"}
    />
  );
})

export const DateCreatedField = observer((props: FieldProps) => {
  return (
    <FormField
      id="date-created"
      labelKey="general.date-created"
      readOnly
      fieldValue={props.value ? dateService.formatDate(props.value) : "-"}
    />
  );
})

export const CreatedByField = observer((props: FieldProps) => {
  return (
    <FormField
      id="created-by"
      labelKey="general.created-by"
      readOnly
      fieldValue={props.value || "-"}
    />
  );
})